<style lang="scss" scoped>
	@import "./subscriptonnew.css";
	.warp_width{
		width: 100%;
	}
</style>
<template>
	<div id="subscriptonnew">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<a-row >
					<a-col :xl="{ span: 24 }">
						<a-row type='flex' justify='space-between'>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="股票名稱" class="formItem">
									<a-input v-model="params.stockname" placeholder="請輸入股票名稱"  :allowClear="true" @change="handleClear(1)"/>
								</a-form-model-item>
							</a-col>
							
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="股票代碼" class="formItem">
									<a-input v-model="params.stockcode" placeholder="請輸入股票代碼" :allowClear="true" @change="handleClear(2)"/>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="上市行業" class="formItem">
									<!-- <a-select v-model="params.cn_planned_industry_name_cn" placeholder="請選擇上市行業">
										<a-select-option v-for="(item) in khtypeArrs" :key="item.key"
											:value="item.value">{{item.text}}</a-select-option>
									</a-select> -->
									<Situationall v-model="params.cn_planned_industry_name_cn" :url='$api.getParamList'
										:params='{"type":"industrys"}' :style='"width:100%"' :placeholder="'請選擇上市行業'">
									</Situationall>
									<!-- <a-input v-model="params.cn_planned_industry_name_cn" placeholder="請輸入上市行業" /> -->
								</a-form-model-item>
							</a-col>
							
						</a-row>
						<br>
						<a-row type='flex' justify='space-between'>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="提交時間" class="formItem">
									<a-date-picker v-model="params.submissionTime"  class='warp_width' placeholder='提交時間' />
								</a-form-model-item>
							</a-col>
							
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="審批時間" class="formItem">
									<a-date-picker v-model="params.approvalTime"  class='warp_width' placeholder='審批時間' />
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 6 }"
								style="display: flex;align-items: center;">
								<div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" @click="searchEvent">
									<img src="../../image/icon_sousuo.png" class="btnIcon" />
									<span>搜索</span>
								</div>
								<div class="btn_cla" style="background-color:#ffa647;"
									@click="clearEvent">
									<img src="../../image/icon_chongzhi.png" class="btnIcon" />
									<span>重置</span>
								</div>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<a-button v-if='ipoAdmin' class="bottomBtn" style="background-color:#ffa647;" @click='isopen = true'>
					<img src="../../image/icon_tianjia.png" class="btnIcon" />
					<span>添加</span>
				</a-button>
				<a-button v-if='ipoAduitAdmin' class="bottomBtn" style="background-color:#ed4849;" @click="handDelect">
					<img src="../../image/icon_shanchu.png" class="btnIcon" />
					<span>刪除</span>
				</a-button>
				<a-button class="bottomBtn" style="background-color:#3bc7a1;" @click='handopen' v-if='ipoAduitAdmin'>
					<img src="../../image/icon_word.png" class="btnIcon"/>
					<span>導出</span>
				</a-button>
				<a-upload name="file" :data='{token:$store.state.token}' :headers='{token:$store.state.token}'
					class="avatar-uploader" :show-upload-list="false" :action="$api.uploadPicwew"
					:before-upload="beforeUpload" @change="handleChange">
					<a-button v-if='ipoAdmin' class="bottomBtn" style="background-color:rgb(88, 133, 234);">
						<img src="../../image/icon_daochu.png" class="btnIcon" />
						<span>導入</span>
					</a-button>
				</a-upload>
				<a-button v-if='ipoAduitAdmin&&params.missionflag>0' class="bottomBtn" style="background-color:#a06bf1;" @click="handipo">
					<img src="../../image/handall.png" class="btnIcon" />
					<span>批量審核</span>
				</a-button>
				<task :params='params' @child='fandfn'></task>
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<span slot='alltext' style="font-size: 0.85rem;position: relative;left: -2.8rem;"></span>
				<span slot='stockname1' style="font-size: 0.85rem;position: relative;right: -2rem;">股票名稱</span>
				<!-- :scroll="{ y: 'calc(100vh - 430px)', x: '100vw'}" -->
				<div slot='hot_status' slot-scope="record" style="white-space: nowrap;" :title='record.stockname'>
					<div v-if='record.hot_status == 1' style='display: inline-block;margin-right: 5px;'><img :src="icon_fasong" alt="" style='width: 1rem;'></div>
					<div v-if='record.hot_status == 2' style='display: inline-block;margin-right: 5px;'><img :src="icon_hot" alt="" style='width: 1rem;'></div>
					<div style='display: inline-block;'>
						{{record.stockname}}
					</div>
				</div>
				<!-- 显示状态 -->
				<div slot="schedule" slot-scope="record">
					<div class="tableRowView1">
						<img :src="record.schedule > 0||record.handle == 1 ? icon_one : icon_one1" alt=""
							class="imageC">
						<div class="lineC"
							:style="!(record.schedule == 1&&record.handle == 2)&&(record.schedule > 0||record.handle == 1)? 'background:#467fff;' : ''">
							<span v-if="record.schedule <= 1&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule > 1||(record.schedule == 1&&record.handle == 1) ? icon_two : icon_two1"
							alt="" class="imageC">
						<!-- <div class="lineC"
							:style="!(record.schedule == 2&&record.handle == 2)&&(record.schedule > 1||(record.schedule == 1&&record.handle == 1)) ? 'background:#6cce68;' : ''">
							<span v-if="record.schedule == 2&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule > 2 ||(record.schedule == 2&&record.handle == 1)? icon_three : icon_three1"
							alt="" class="imageC"> -->
							
							
							
						<!-- <div class="lineC" :style="!(record.schedule == 3&&record.handle == 2)&&record.schedule > 2 ||
						(record.schedule == 3&&record.handle == 0) ? 'background:#f7d429;' : ''">
							<span v-if="record.schedule == 3&&record.handle == 2" class="redX">x</span></div>
						<img :src="record.schedule > 3 ||(record.schedule == 3&&record.handle == 1) ? icon_four : icon_four1"
							alt="" class="imageC"> -->
					</div>
				</div>
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div class="popoverView">
							<img :src="record.visible_bold ? icon_pdf1 : icon_pdf"
								class="imageC" @click='island = true;itemdata = record;record.visible_bold=true'>
						</div>
						<!-- <div class="popoverView">
							<img :src="record.shShowBol ? icon_bianji1 : icon_bianji" class="imageC" 
							 @click='isshShowBol = true;itemdata=record;record.shShowBol=true'>
						</div>
						<div class="popoverView popoverView3">
							<pushbtn :record='record' @child='handclose' :params='params'></pushbtn>
						</div> -->
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<handhome v-if='isopen||island' :isopen='isopen' @child='handclose' :record='itemdata' :missionflag='params.missionflag'></handhome>
		<shenhe v-if='isshShowBol' :island='isshShowBol' @child='handclose' :record='itemdata'></shenhe>
	
		<!-- <handItems v-if='(ipoAdmin||ipoAdmin3)&&island'  :island='island' @child='handclose'  :record='itemdata' :missionflag='params.missionflag'></handItems>
	<handlook v-else-if='island' :island='island'
		@child='handclose' :record='itemdata' :missionflag='params.missionflag'></handlook> -->
	</div>
</template>

<script>
	import handhome from './comhome/handhome.vue'
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import handItem from './components/handItem.vue'
	import shenhe from './components/shenhe.vue'
	import handItems from './components/handItems.vue'
	import handlook from './components/handlook.vue'
	import App from '@/assets/app.js';
	import icon_pdf from '@/image/icon_xiangqing.png';
	import icon_pdf1 from '@/image/icon_xiangqing_1.png';
	import icon_one from '../../image/subscr/bianji.png';
	import icon_one1 from '../../image/subscr/bianji2.png';
	import icon_two from '../../image/subscr/shenhe.png';
	import icon_two1 from '../../image/subscr/bianji1.png';
	import icon_three from '../../image/subscr/mazhan.png';
	import icon_three1 from '../../image/subscr/mazhan1.png';
	import icon_four from '../../image/icon_4.png';
	import icon_four1 from '../../image/icon_4_1.png';
	import wj_dlsfzOff from '../../image/wj_dlsfzOff.png';
	import icon_bianji from '@/image/icon_mess_1.png';
	import icon_bianji1 from '@/image/icon_mess.png';
	import wj_dz from '../../image/wj_dz.png';
	import wj_hkd from '../../image/wj_hkd.png';
	import wj_hksfzOff from '../../image/wj_hksfzOff.png';
	import wj_hz from '../../image/wj_hz.png';
	import wj_sfzOn from '../../image/wj_sfzOn.png';
	import wj_wgsfzOff from '../../image/wj_wgsfzOff.png';
	import wj_txz from '../../image/wj_txz.png';
	import {
		saveFileToLink
	} from 'web-downloadfile';

	import metemail from './components/metemail'
	import pushbtn from './components/pushbtn.vue'
	import ediotable from './components/ediotable.vue'
	import task from './components/task.vue'
	export default {
		components: {
			handhome,
			handItem,
			pushbtn,
			ediotable,
			metemail,
			task,handItems,shenhe,handlook
		},
		data() {
			return {
				icon_bianji,
				icon_bianji1,
				icon_pdf,
				icon_pdf1,
				island:false,
				isshShowBol:false,
				itemdata:{},
				isopen: false,
				icon_fasong: require('@/image/icon_fasong.png'),
				icon_hot: require('@/image/icon_hot.png'),
				icon_one,
				icon_one1,
				icon_two,
				icon_two1,
				icon_three,
				icon_three1,
				icon_four,
				icon_four1,
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限     审批管理员 ipoAduitAdmin 审批权限
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				// ipoAdmin3 比 之前的權限 ipoAdmin 多出三個字符轉編輯權限
				ipoAdmin3: this.$store.state.rolesdata.indexOf('ipoAdmin3') >= 0,
				admintypeArr: [{
						text: '全部',
						value: ''
					},{
						text: '處理中',
						value: '0'
					},
					{
						text: '認購中',
						value: '1'
					},
					{
						text: '待上市',
						value: '2'
					},
					{
						text: '已上市',
						value: '3'
					},
				],
				admintypeArrs: [{
						text: '主板',
						value: '0'
					},
					{
						text: '創業板',
						value: '1'
					},
				],
				khtypeArr: [{
						text: '全部',
						value: ''
					},
					{
						text: '推送',
						value: 1
					},
					{
						text: '熱門',
						value: 2
					},
				],
				khtypeArrs: [],
				tzPageNum: '',
				columns: [
					// {
						// title: '',
						// dataIndex: '',
						// align: 'right',
						// width: '3%',
						// slots: {
						// 	title: 'alltext'
						// },
						// scopedSlots: {
						// 	customRender: 'hot_status'
						// }
					// },
					{
						// title: '股票名稱',
						dataIndex: '',
						align: 'left',
						width: '10%',
						slots: {
							title: 'stockname1'
						},
						scopedSlots: {
							customRender: 'hot_status'
						},
					},
					{
						title: '股票代碼',
						dataIndex: 'stockcode',
						align: 'center',
						width: '12%'
					},
					{
						title: '上市行業',
						dataIndex: 'status_cn',
						align: 'center',
						width: '12%'
					},
					{
						title: '提交時間',
						dataIndex: 'createtime',
						align: 'center',
						width: '12%'
					},
					{
						title: '操作人員',
						dataIndex: 'realname',
						align: 'center',
						width: '12%'
					},
					
					{
						title: '審批進度',
						dataIndex: '',
						align: 'center',
						width: '15%',
						scopedSlots: {
							customRender: 'schedule'
						}
					},
					{
						title: '審批時間',
						dataIndex: 'processdate',
						align: 'center',
						width: '12%'
					},
					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				khtypeArrbj: [],
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					searchstr: '',
					hot_status: '',
					perPage: 10, //每頁條目數
					stockname: '', //李百控股    股票名稱
					stockcode: '', //股票代碼
					status_cn: '', //處理中，認購中，待上市，已上市 //上市狀態
					plates_cn: '', //上市板塊
					baojianr: '', //保薦機構
					cn_planned_industry_name_cn: '', //服務業 //上市行業
					applicationdate_begin: '', //認購起始日期
					applicationdate_end: '', //認購截止日期
					timeDate: [],
					missionflag: 0,
					submissionTime:'',
					approvalTime:'',

				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
			// this.handland("industrys")
			// this.handland("baojianr")
		},
		methods: {
			
            handleClear(val){
				if (val==1) {
					if (!this.params.stockname) {
						this.messLoad()
					}
				}
				if (val==2) {
					if (!this.params.stockcode) {
						this.messLoad()
					}
					
				}
               
            },
			handopen(){
				if (this.selectedRows.length > 0) {
					let str = ''
					let arr =[]
					this.selectedRows.map(ev => {
						if(str){
							str += ',' + this.columnsData[ev].iposelling_id
						}else{
							str = this.columnsData[ev].iposelling_id
						}
						arr.push(this.columnsData[ev].iposelling_id)
					})
				
					this.$ajax({
						method: 'post',
						url: this.$api.getstockstables,
						data:{"idList":arr}
					}).then(res => {
						if (res.data.qmiscode == 1000) {
							window.open(this.$api.openurls+ '/png' + '?idlist='+str)
						} else {
							App.oTool.warningT(res.data.qmismsg);
						}
					})
					}else{
						this.$message.error('請選擇數據');
					}
			},
			fandfn(val){
				this.params.schedule = ''
				if(val == 'back'){
					this.params.missionflag = 0
					this.params.schedule = ''
					this.params.status_cn=''
				}else{
					this.params.missionflag = 1
					this.params.schedule = val
					this.params.status_cn=val
				}
				this.messionEvent()
			},
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
			handipo(){//ipoAdmin
				if (this.selectedRows.length > 0) {
					let dlist = []
					this.selectedRows.map(ev => {
						dlist.push(this.columnsData[ev].iposelling_id)
					})
					
					this.$ajax({
						method: 'post',
						url: this.$api.ipoAdmin,
						headers: {
							token: this.$store.state.token
						},
						data: {
							"token": this.$store.state.token,
							"aduitList": dlist
						}
					}).then(res => {
						if (res.data.qmiscode === 1000) {
							App.oTool.successT();
							this.selectedRows = []
							this.messLoad();
						} else {
							App.oTool.warningT(res.data.qmismsg);
						}
					})
				} else {
					App.oTool.warningT("請選擇一條數據審批!");
				}
			},
			handDelect() {
				if (this.selectedRows.length > 0) {
					let dlist = []
					this.selectedRows.map(ev => {
						dlist.push(this.columnsData[ev].iposelling_id)
					})
					
					this.$ajax({
						method: 'post',
						url: this.$api.dropDelete,
						headers: {
							token: this.$store.state.token
						},
						data: {
							"token": this.$store.state.token,
							"idList": dlist
						}
					}).then(res => {
						if (res.data.qmiscode === 1000) {
							App.oTool.successT();
							this.selectedRows = []
							this.messLoad();
						} else {
							App.oTool.warningT(res.data.qmismsg);
						}
					})
				} else {
					App.oTool.warningT("請選擇一條數據刪除!");
				}
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.applicationdate_begin = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]
						._d) : '',
					//認購截止日期
					this.params.applicationdate_end = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]
						._d) : ''
			},
			handland(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"type": val
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						let obj = []
						res.data.result.map(val => {
							obj.push({
								text: val,
								value: val
							})
						})
						if (val === 'industrys') {
							this.khtypeArrs = obj
						} else if (val === 'baojianr') {
							this.khtypeArrbj = obj
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			downhand(){
				this.dwonopen = false
			},
			handclose(val) {
				this.columnsData.map(ev => {
					for (let key in ev) {
						ev['shShowBol'] = false;
						ev['shKhadmin1Bol'] = false;
						ev['visible_bold'] = false;
					}
				})
				console.log('+++++++++++++++++')
				this.isopen = false
				this.island = false
				console.log(this.island)
				this.isshShowBol = false
				this.itemdata= {}
				// if (val) {
				this.messLoad();
				// }
			},
			messLoad() {
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.getUsMarketStockList,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.result
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['shShowBol'] = false;
								ev['visible_bold'] = false;
								ev['shKhadmin1Bol'] = false;
							}
						})
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.params.missionflag = 0;
				this.messLoad();
			},
			clearEvent() {
				this.params = {}
				this.params = {
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					stockname: '', //李百控股    股票名稱
					stockcode: '', //股票代碼
					status_cn: '', //處理中，認購中，待上市，已上市 //上市狀態
					plates_cn: '', //上市板塊
					baojianr: '', //保薦機構
					cn_planned_industry_name_cn: '', //服務業 //上市行業
					applicationdate_begin: '', //認購起始日期
					applicationdate_end: '', //認購截止日期
					timeDate: [],
					missionflag: 0
				}
				this.messLoad();
			},
			messionEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},

			substr(str, a, b) {
				return str.toString().substring(a, b)
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
	};
</script>
